import React from "react";
import { getURLHelper } from "../../helpers/url";
import SocialMediaIcon from './sub-components/SocialMediaIcon'

const SocialColumn = ({
    menuStyleData,
    sideMenu,
    footerContent,
    footerTextColor,
    spaceClass,
    order,
    boxWidth
}) => {
    let menuAnchorStyle = {
        fontFamily: menuStyleData && menuStyleData.menuFont,
        color: menuStyleData && menuStyleData.menuFontcolor,
        fontSize: menuStyleData && (menuStyleData.menuFontsize + "px"),
        display: 'inline-flex',
    }
    const textAlignment = menuStyleData?.menuTextAlignment 
    return (
        <div className={textAlignment ?? 'text-left'}
            style={{order:(order ? order : 4), width:boxWidth, flex:`0 0 ${boxWidth}`}}>
        <div
            className={`footer-widget  ${!!footerTextColor ? footerTextColor :""} 
            ${spaceClass?.pt} ${spaceClass?.pb} ${spaceClass?.pl} ${spaceClass?.pr} ${spaceClass?.mb} ${spaceClass?.mt} ${spaceClass?.mr} ${spaceClass?.ml}`}
        >
            <div className="footer-title">
                <h3 style={{
                    fontFamily: menuStyleData.menuFont,
                    color: menuStyleData?.titleFontColor || menuStyleData?.menuFontcolor,
                    fontSize: menuStyleData?.titleFontSize && (menuStyleData.titleFontSize + "px"),
                }}> {(footerContent && footerContent.socialLinkTitle != "undefined" && footerContent.socialLinkTitle != undefined && footerContent.socialLinkTitle != "") ? footerContent.socialLinkTitle : ""}</h3>
            </div>
            <div className="footer-list">
                <ul style={{display: 'flex', gap: '16px', justifyContent: textAlignment === "text-right" ? "flex-end" : textAlignment=== "text-left" ? "flex-start" : "center", flexWrap: 'wrap'}}>
                    {footerContent && footerContent.socialLink && footerContent.socialLink.length > 0 &&
                        footerContent.socialLink.map((data, key) => {
                            return (
                                <li key={key}>

                                        {
                                            getURLHelper(data.iconLink) ?
                                            <a href={getURLHelper(data.iconLink)} target="_blank"
                                            onMouseOver={(e) => e.target.style.color = menuStyleData.menuHovercolor}
                                            onMouseOut={(e) => e.target.style.color = menuStyleData.menuFontcolor}
                                            style={menuAnchorStyle}><SocialMediaIcon iconClass={data.iconName} fillColor={menuStyleData.menuFontcolor} hoverColor={menuStyleData.menuHovercolor} /></a>
                                                : <span 
                                                onMouseOver={(e) => e.target.style.color = menuStyleData.menuHovercolor}
                                                onMouseOut={(e) => e.target.style.color = menuStyleData.menuFontcolor}
                                                style={menuAnchorStyle}><SocialMediaIcon iconClass={data.iconName} fillColor={menuStyleData.menuFontcolor} hoverColor={menuStyleData.menuHovercolor} /></span>
                                        }
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    </div>
    )
}

export default SocialColumn
